import React from "react";

function Navbar() {
  const handleSmoothScroll = (e, targetId) => {
    e.preventDefault();
    const targetElement = document.querySelector(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <nav className="bg-white shadow sticky top-0 z-10">
      <div className="mx-auto px-6 py-4 flex justify-between items-center">
        <h1 className="text-xl font-bold text-blue-600">Stuart Hillier</h1>
        <ul className="flex space-x-4">
          <li>
            <a
              href="#about"
              className="hover:text-blue-600"
              onClick={(e) => handleSmoothScroll(e, "#about")}
            >
              About
            </a>
          </li>
          <li>
            <a
              href="#experience"
              className="hover:text-blue-600"
              onClick={(e) => handleSmoothScroll(e, "#experience")}
            >
              Experience
            </a>
          </li>
          <li>
            <a
              href="#contact"
              className="hover:text-blue-600"
              onClick={(e) => handleSmoothScroll(e, "#contact")}
            >
              Contact
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
